import "utils/polyfills";
import "utils/sentry";

import { h, render } from "preact";
import { App } from "app";

const root = document.getElementById("root");

if (root) render(<App />, root);
